export default "__VITE_ASSET__DO92K0J2__"